import { getAxiosInstance } from "../ApiConfig";

async function FetchAllContact() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactByDep() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPaginationByDep(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany?page=${page}&limit=${limit}`);
        return response.data.items
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactSearchByDep(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPaginationSearchByDep(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCompanyContacts`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchContactDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByContactId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getContactScore(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getContactScore/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchContactByAccount(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllContactsByAccount/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchContactByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllContactByDeal/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ContactScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchContactScoreByContactId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ContactConnectioncheck(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/findContactConnections`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ContactMergerUpadet(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateContactsInMerge/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function mergeContactDelte(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteContactInMerge`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateContact(payload) {
    try {
         const { actionType, ...body } = payload;
                const url = actionType
                    ? `/usermgmt/massUpdateContact?actionType=${actionType}`
                    : `/usermgmt/massUpdateContact`;
                const response = await getAxiosInstance().put(url, body);
                return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteContact(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteContact`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createContacts(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createContacts`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateContacts(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateContacts/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findContactByContactMail(email, companyId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findContactByContactMail/${email}/${companyId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    getContactScore,
    findContactByContactMail,
    massDeleteContact,
    massUpdateContact,
    FetchContactDetails,
    FetchContactByAccount,
    FetchContactByDeal,
    ContactScoreData,
    FetchAllContactByCompany,
    ContactConnectioncheck,
    mergeContactDelte,
    ContactMergerUpadet,
    FetchAllContact,
    AllContactPagination,
    AllContactPaginationSearch,
    FetchAllContactSearch,
    FetchAllContactByDep,
    AllContactPaginationByDep,
    AllContactPaginationSearchByDep,
    FetchAllContactSearchByDep,
    createContacts,
    updateContacts,
}